import { render } from "./Selectbox.vue?vue&type=template&id=4bfca812&scoped=true"
import script from "./Selectbox.vue?vue&type=script&lang=js"
export * from "./Selectbox.vue?vue&type=script&lang=js"

import "./Selectbox.vue?vue&type=style&index=0&id=4bfca812&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4bfca812"

export default script